export enum ErrorCode {
  USER_LOGIN_WITHOUT_UX_REPUBLIC_ADDRESS = 'USER_LOGIN_WITHOUT_UX_REPUBLIC_ADDRESS',
  USER_LOGIN_FAILED = 'USER_LOGIN_FAILED',
}
